import { useEffect, useRef, useState } from 'react'

/** Sets `inView` true the first time the element scrolls into view, then unobserves. */
export function useInView<T extends HTMLElement = HTMLDivElement>(
  options: IntersectionObserverInit = { threshold: 0.12, rootMargin: '0px 0px -7% 0px' },
) {
  const ref = useRef<T>(null)
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    if (typeof IntersectionObserver === 'undefined') {
      setInView(true)
      return
    }
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          setInView(true)
          io.unobserve(e.target)
        }
      }
    }, options)
    io.observe(el)
    return () => io.disconnect()
    // options is intentionally not a dependency — it's a fresh literal each render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { ref, inView }
}
